import React, { memo } from 'react';

import { CustomizedTooltip } from 'components/common/CustomizedTooltip/CustomizedTooltip';
import { ProfileImage } from 'components/common/ProfileImage/profileImage';

import { IAssignee } from 'components/Dashboards/Program/Dashboard/ProgramDashboardComponents/Battlecards/battlecards.types';

interface IAssigneeAvatar {
    assignee: IAssignee;
    classname?: string;
}

export const AssigneeAvatar = memo(({ assignee, classname = '' }: IAssigneeAvatar) => {
    const isUnassigned = assignee.userName === 'Unassigned';

    return (
        <CustomizedTooltip
            tooltipContent={`${assignee.firstName} ${assignee.lastName}`}
            triggerElement={
                <ProfileImage
                    classname={classname}
                    isUnassigned={isUnassigned}
                    fullName={`${assignee.firstName} ${assignee.lastName}`}
                    email={assignee.userName}
                    imageName={assignee.imageName}
                />
            }
        />
    );
});
